/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash cda0f807c9e2dedb44952b0ec05dedfd */

import { ConcreteRequest } from "relay-runtime";

export type fetchUserMetadataQueryVariables = {
    email?: string | null | undefined;
};
export type fetchUserMetadataQueryResponse = {
    readonly viewer: {
        readonly disableCompleteAccountEmail: boolean | null;
        readonly userExistsMetadata: {
            readonly userExists: boolean | null;
            readonly emailOnly: boolean | null;
            readonly hasPassword: boolean | null;
        } | null;
    };
};
export type fetchUserMetadataQuery = {
    readonly response: fetchUserMetadataQueryResponse;
    readonly variables: fetchUserMetadataQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "email"
        } as any
    ], v1 = {
        "alias": "disableCompleteAccountEmail",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "disableCompleteAccountEmail"
            }
        ],
        "kind": "ScalarField",
        "name": "isEnabled",
        "storageKey": "isEnabled(key:\"disableCompleteAccountEmail\")"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userExists",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailOnly",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPassword",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "fetchUserMetadataQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": (v2 /*: any*/),
                            "concreteType": "UserExistsMetadataType",
                            "kind": "LinkedField",
                            "name": "userExistsMetadata",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "fetchUserMetadataQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": (v2 /*: any*/),
                            "concreteType": "UserExistsMetadataType",
                            "kind": "LinkedField",
                            "name": "userExistsMetadata",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v6 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/fetchUserMetadataQuery",
            "metadata": {},
            "name": "fetchUserMetadataQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '6d867dae546608c43f089a097be1705d';
export default node;
